import {
  AccountTreeOutlined,
  CodeOutlined,
  CollectionsBookmarkOutlined,
  FileCopyOutlined,
  GavelOutlined,
  LinkOutlined,
  LocalOfferOutlined,
  MailOutlined,
  PermMediaOutlined,
  QuizOutlined,
  ScreenSearchDesktopOutlined,
  SmartToyOutlined,
  SpeakerNotesOutlined,
} from '@mui/icons-material';
import { IMenu } from '@dfl/mui-react-common';
import { TESTIMONY_PERMISSIONS } from 'modules/cms/testimony/constants';
import { COLLECTIONS_PERMISSIONS } from 'modules/cms/collections/constants';
import { SeoAuditIcon } from 'components/icons/SeoAuditIcon';
// import { SocialManagerIcon } from 'components/icons/menus/SocialManagerIcon';
import KeywordIcon from 'components/icons/offer-sales/KeywordIcon';
import { MEDIA_PERMISSIONS } from 'modules/cms/medias/constants/medias.permissions';
import { KEYWORD_PERMISSIONS } from 'modules/cms/seo/keyword/constants';
import { SEO_PERMISSIONS } from 'modules/cms/seo/common/constants/seo.permissions';
import { EMAIL_TEMPLATE_PERMISSIONS } from 'modules/settings/email-templates/constants';
import { SPECIAL_OFFER_PERMISSIONS } from 'modules/sales-offer/special-offer/constants';
import { disabledSpecialOffer, disabledCmsTestimonials, disabledCmsSeoAuditReport, disabledFAQ } from 'utils/flags-utils';
import { FAQ_PERMISSIONS } from 'modules/cms/faq/constants';
import { TERMS_PERMISSIONS } from 'modules/cms/terms/constants';
import { SHORT_LINK_PERMISSIONS } from 'modules/cms/short-links/constants/short-link.permissions';

export const CMS_MENU: IMenu[] = [
  {
    title: 'main_menu.admin.section.cms.collection',
    prefix: '/cms',
    atLessOne: true,
    items: [
      {
        title: 'collection:list',
        path: '/cms/collections',
        partialMatch: true,
        icon: <CollectionsBookmarkOutlined fontSize='small' />,
        permissions: [COLLECTIONS_PERMISSIONS.COLLECTIONS_VIEW],
      },
      ...(!disabledSpecialOffer ? [{
        title: 'specialOffer:list',
        path: '/cms/special-offers',
        partialMatch: true,
        icon: <LocalOfferOutlined fontSize='small' />,
        permissions: [SPECIAL_OFFER_PERMISSIONS.SPECIAL_OFFER_VIEW],
      }] : []),
      ...(!disabledCmsTestimonials ? [{
        title: 'testimony:list',
        path: '/cms/testimonials',
        partialMatch: true,
        icon: <SpeakerNotesOutlined fontSize='small' />,
        permissions: [TESTIMONY_PERMISSIONS.TESTIMONY_VIEW],
      }] : []),

      /*   {
        title: 'main_menu.admin.section.cms.email-template',
        path: '/cms/email-template',
        partialMatch: true,
        icon: <EmailOutlined fontSize='small' />,
      }, */
    ],
  },
  {
    title: 'main_menu.admin.section.cms.content',
    prefix: '/pages',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.cms.pages',
        path: '/cms/pages',
        partialMatch: true,
        icon: <FileCopyOutlined fontSize='small' />,
        permissions: [MEDIA_PERMISSIONS.MEDIA_VIEW],
      },
      {
        title: 'main_menu.admin.section.cms.terms',
        path: '/cms/terms',
        partialMatch: true,
        icon: <GavelOutlined fontSize='small' />,
        permissions: [TERMS_PERMISSIONS.TERMS_VIEW],
      },
      {
        title: 'main_menu.admin.section.settings.email-templates',
        path: '/cms/email-templates',
        partialMatch: true,
        icon: <MailOutlined fontSize='small' />,
        permissions: [EMAIL_TEMPLATE_PERMISSIONS.EMAIL_TEMPLATE],
      },
      ...(!disabledFAQ ? [{
        title: 'main_menu.admin.section.cms.faq',
        path: '/cms/faqs',
        partialMatch: true,
        icon: <QuizOutlined fontSize='small' />,
        permissions: [FAQ_PERMISSIONS.FAQ_VIEW],
      }] : []),
      {
        title: 'main_menu.admin.section.cms.short-links',
        path: '/cms/short-links',
        partialMatch: true,
        icon: <LinkOutlined fontSize='small' />,
        permissions: [SHORT_LINK_PERMISSIONS.SHORT_LINK_VIEW],
      },
    ],
  },

  {
    title: 'main_menu.admin.section.cms.resources',
    prefix: '/medias',
    atLessOne: true,
    items: [
      {
        title: 'media:list',
        path: '/cms/medias',
        partialMatch: true,
        icon: <PermMediaOutlined fontSize='small' />,
        permissions: [MEDIA_PERMISSIONS.MEDIA_VIEW],
      },
    ],
  },
  {
    title: 'main_menu.admin.section.cms.seo',
    prefix: '/cms/seo',
    atLessOne: true,
    items: [
      /* {
        title: 'main_menu.admin.section.cms.social-manger',
        path: '/cms/seo/social-manger',
        partialMatch: true,
        icon: <SocialManagerIcon fontSize='small' />,
      permissions: [SEO_PERMISSIONS.SEO_VIEW]
      }, */
      {
        title: 'main_menu.admin.section.cms.keyword',
        path: '/cms/seo/keywords',
        partialMatch: true,
        icon: <KeywordIcon fontSize='small' />,
        permissions: [KEYWORD_PERMISSIONS.KEYWORD_VIEW],
      },
      /* {
        title: 'main_menu.admin.section.cms.ai-assistant',
        path: '/cms/seo/ai-assistant',
        partialMatch: true,
        icon: <AiAssistantIcon fontSize='small' />,
        permissions: [SEO_PERMISSIONS.SEO_VIEW]
      }, */
      {
        title: 'seo:settings.robot_txt:title',
        path: '/cms/seo/robot_txt',
        partialMatch: true,
        icon: <SmartToyOutlined fontSize='small' />,
        permissions: [SEO_PERMISSIONS.SEO_VIEW],
      },
      {
        title: 'seo:settings.llm_txt:title',
        path: '/cms/seo/llm_txt',
        partialMatch: true,
        icon: <CodeOutlined fontSize='small' />,
        permissions: [SEO_PERMISSIONS.SEO_VIEW],
      },
      {
        title: 'seo:settings:static_site_map_item:title',
        path: '/cms/seo/static_site_map_items/general',
        partialMatch: true,
        icon: <ScreenSearchDesktopOutlined fontSize='small' />,
        permissions: [SEO_PERMISSIONS.SEO_VIEW],
      },
      {
        title: 'seo:settings:sitemap:title',
        path: '/cms/seo/sitemap',
        partialMatch: true,
        icon: <AccountTreeOutlined fontSize='small' />,
        disabled: true,
        permissions: [SEO_PERMISSIONS.SEO_VIEW],
      },
    ],
  },
  ...(!disabledCmsSeoAuditReport ? [{
    title: 'main_menu.admin.section.general.reports',
    prefix: '/cms/reports',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.cms.seo-audit',
        path: '/cms/reports/seo-audit',
        partialMatch: true,
        icon: <SeoAuditIcon fontSize='small' />,
      },
    ],
  }] : []),
];
